import {Injectable, Pipe, PipeTransform} from '@angular/core'

@Pipe({
  name: 'filterTool'
})
@Injectable()
export class FilterToolPipe implements PipeTransform {
  transform(tools: any[], args: any[]): any {
    return tools.filter(t => t.visible === true)
  }
}